import { Rarity } from '#src/__generated__/globalTypes.ts';
import { Shards } from '#src/atoms/icons/Shards.tsx';
import { isSupportedCardSet } from '#src/lib/cardSets.tsx';
import { getRarityShardColor } from '#src/lib/colors.ts';
import type { unitMapping } from '#src/lib/style.ts';

type Props = {
  cardSetSlug?: string | null;
  size?: keyof typeof unitMapping;
  className?: string;
  gradient?: 'purple';
};
export const CommonShards = ({
  cardSetSlug,
  size = 2,
  className,
  gradient,
}: Props) => {
  const shardColor = getRarityShardColor(
    Rarity.common,
    isSupportedCardSet(cardSetSlug) ? cardSetSlug : null
  );
  return (
    <Shards
      color={shardColor}
      size={size}
      className={className}
      gradient={gradient}
    />
  );
};
